import React from "react";
import useReveal from "../hooks/useReveal";
import ContactSection from "../components/ContactSection";
import FAQSection from "../components/FAQSection";
import { FEES_PAGE, IMAGES, META, FAQ_SECTIONS } from "../mock";
import useDocMeta from "../hooks/useDocMeta";

export default function Fees() {
  useReveal();
  useDocMeta(META.fees);
  return (
    <div>
      <section className="relative pt-36 pb-8 sm:pt-44 sm:pb-10 bg-gradient-to-b from-brand-50 to-sand-50 overflow-hidden">
        <div className="absolute -top-24 right-0 h-80 w-80 rounded-full bg-brand-200/40 blur-3xl" />
        <div className="relative max-w-6xl mx-auto px-5 sm:px-8">
          <span className="text-brand-500 font-semibold tracking-[0.2em] text-xs uppercase">{FEES_PAGE.subtitle}</span>
          <h1 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl text-brand-900 text-balance">{FEES_PAGE.title}</h1>
        </div>
      </section>

      <section className="pt-6 pb-12 sm:pt-8 sm:pb-16 bg-white">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 grid lg:grid-cols-5 gap-12 lg:items-stretch">
          <div className="lg:col-span-3 reveal">
            <div className="space-y-5">
              {FEES_PAGE.items.map((it, i) => (
                <div key={i} className="rounded-2xl bg-white border border-brand-100 p-6 shadow-sm">
                  <h3 className="font-display text-xl text-brand-800">{it.heading}</h3>
                  <p className="mt-2 text-brand-900/75 leading-relaxed">{it.body}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="lg:col-span-2 reveal grid grid-rows-2 gap-5" data-testid="fees-photos">
            {[IMAGES.stones, IMAGES.quietZone].map((src, i) => (
              <div key={i} className="relative rounded-[2rem] overflow-hidden shadow-[0_30px_70px_-45px_rgba(31,56,53,0.5)] aspect-[4/3] lg:aspect-auto">
                <img src={src} alt="AwareHub clinic" className="absolute inset-0 h-full w-full object-cover" />
              </div>
            ))}
          </div>
        </div>
      </section>

      <FAQSection background="bg-brand-50" sections={[FAQ_SECTIONS.feesInsurance]} pageTitle="Fees & Insurance — Frequently Asked Questions" />

      <ContactSection />
    </div>
  );
}
